import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import LanguageIcon from '@material-ui/icons/Language';
import { DomainsPage } from './DomainsPage';

// routeRef explícito + icon são obrigatórios pra aparecer no menu lateral -
// mesmo motivo documentado em ../users/index.tsx. O item é escondido de quem
// não é admin lá (mesma permissão de "Pipelines").
export const domainsRouteRef = createRouteRef();

const domainsPage = PageBlueprint.make({
  name: 'domains',
  params: {
    path: '/domains',
    title: 'Domínios',
    icon: <LanguageIcon />,
    routeRef: domainsRouteRef,
    loader: async () => <DomainsPage />,
  },
});

export const domainsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [domainsPage],
});
